module.exports = __webpack_public_path__ + "static/media/3.c7e3fc86.jpg";